export const apiKey = {
  production: 'AIzaSyAidR6Tt0K60gACR78aWThMQb7L5u6Wpag',
  develop: 'AIzaSyCUq3JkyEgJ2WJuTj-KQyaQXgY59d8z4MQ'
};
